import { apiClient } from "@/core/api/ApiClient";
import { EntityType, MaintenanceDto } from "@/core/api/generated/v1";

import BaseEntitiesDeleteModal, {
  BaseEntitiesDeleteModalInheritableProps,
} from "../components/BaseEntitiesDeleteModal";

export interface OwnProps {
  entities: MaintenanceDto[];
}

type Props = OwnProps & BaseEntitiesDeleteModalInheritableProps;

export default function MaintenancesDeleteModal({ entities, ...otherProps }: Props) {
  return (
    <BaseEntitiesDeleteModal
      cascadeActionDisplay={true}
      entityType={EntityType.Maintenance}
      entities={entities}
      deleteFunc={async (params) => {
        await apiClient.maintenancesApi.apiV1MaintenancesBulkDeleteDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          entityBulkDeleteDto: {
            ids: params.entityIds,
            relatedEntitiesTypes: params.relatedEntitiesTypes,
          },
        });
      }}
      {...otherProps}
    />
  );
}
